import { __awaiter } from "tslib";
import { ActivityModuleConfig } from "../../modules/ActivityModule";
import { AdsModuleConfig } from "../../modules/AdsModule";
import { AnalyticsModuleConfig } from "../../modules/AnalyticsModule";
import { CommentsModuleConfig } from "../../modules/CommentsModule";
import { FeedbackModuleConfig } from "../../modules/FeedbackModule";
import { MediaModuleConfig } from "../../modules/MediaModule";
import { NoticesModuleConfig } from "../../modules/NoticesModule";
import { PagesModuleConfig } from "../../modules/PagesModule";
import { PoolModuleConfig } from "../../modules/PoolModule";
import { PostsModuleConfig } from "../../modules/PostsModule";
import { SettingsModuleConfig } from "../../modules/SettingsModule";
import { TermsModuleConfig } from "../../modules/TermsModule";
import API from "@ova-studio/api-helper";
class ModulesRegistry {
    static _isModuleEnabled(name) {
        var _a;
        return (_a = ModulesRegistry._enableModules[name]) !== null && _a !== void 0 ? _a : false;
    }
    static enableModule(name) {
        this._enableModules[name] = true;
    }
    static disableModule(name) {
        this._enableModules[name] = false;
    }
    static registerModule(name, config) {
        this._modules[name] = config;
        this.enableModule(name);
    }
    static getNavigation() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.entries(this._modules)
                .filter(([key]) => this._isModuleEnabled(key))
                .map(([_, i]) => Array.isArray(i.navigation) ? i.navigation : (i.navigation ? [i.navigation] : []))
                .flat()
                .sort((item1, item2) => item1.order - item2.order)
                .map(i => i.item);
        });
    }
    static getGlobalButtons() {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                create: {
                    variant: 'primary',
                    icon: 'plus',
                    title: 'Створити',
                    order: 99,
                    items: {},
                }
            };
        });
    }
    static getNavCounters() {
        return __awaiter(this, void 0, void 0, function* () {
            return API.getData('nav/counters');
        });
    }
    static getRoutes() {
        return Object.entries(this._modules)
            .filter(([key]) => this._isModuleEnabled(key))
            .map(([_, i]) => i.routes)
            .filter(i => !!i)
            .flat(1);
    }
    static initModules(app) {
        var _a;
        for (const [key, module] of Object.entries(this._modules)) {
            if (!this._isModuleEnabled(key)) {
                continue;
            }
            (_a = module.init) === null || _a === void 0 ? void 0 : _a.call(module, app);
        }
    }
}
ModulesRegistry._enableModules = {
    'activity': true,
    'ads': true,
    'analytics': true,
    'comments': true,
    'feedback': true,
    'media': true,
    'notices': true,
    'pages': true,
    'pool': true,
    'posts': true,
    'terms': true,
    'settings': true,
};
ModulesRegistry._modules = {
    'activity': ActivityModuleConfig,
    'ads': AdsModuleConfig,
    'analytics': AnalyticsModuleConfig,
    'comments': CommentsModuleConfig,
    'feedback': FeedbackModuleConfig,
    'media': MediaModuleConfig,
    'notices': NoticesModuleConfig,
    'pages': PagesModuleConfig,
    'pool': PoolModuleConfig,
    'posts': PostsModuleConfig,
    'terms': TermsModuleConfig,
    'settings': SettingsModuleConfig,
};
export default ModulesRegistry;
//# sourceMappingURL=ModulesRegistry.js.map